/* src/app/delivery-defense/dd-manage-subscription/dd-feedback/rating-bar-component/rating-bar-component.component.scss */
.rating-bar {
  display: flex;
  align-items: flex-start;
  gap: 32px;
}
/*# sourceMappingURL=rating-bar-component.component.css.map */
